<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
      </div>
      <!-- /Breadcrumb -->

      <employee-onboarding-documents mode="self" />

      <employee-top></employee-top>

      <div v-if="showPayrollSelfService" class="row mb-3">
        <div class="col-12">
          <div class="card">
            <div
              class="card-body d-flex flex-wrap align-items-center justify-content-between gap-3"
            >
              <div>
                <h6 class="mb-1">Payroll</h6>
                <p class="text-muted small mb-0">
                  View payslips and annual tax certificates.
                </p>
              </div>
              <div class="d-flex flex-wrap gap-2">
                <router-link
                  to="/payroll/my-payslips"
                  class="btn btn-primary btn-sm"
                >
                  My Payslips
                </router-link>
                <router-link
                  to="/payroll/my-p9"
                  class="btn btn-outline-primary btn-sm"
                >
                  My P9
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <attendence-employee v-if="showAttendanceDashboard" />

      <employee-task v-if="showProjectsTasks" />

      <!-- <employee-performance></employee-performance>

      <team-member></team-member> -->
    </div>
    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">
        2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll
      </p>
      <p>
        Powered by
        <a href="#" @click.prevent class="text-primary"
          >DoneQuick Technological World</a
        >
      </p>
    </div>
  </div>
  <employee-dashboard-modal></employee-dashboard-modal>
  <!-- /Page Wrapper -->
</template>

<script setup>
import { computed } from "vue";
import { useAuthStore } from "@/stores/authStore";
import EmployeeOnboardingDocuments from "@/components/hrm/employee-onboarding-documents.vue";

const auth = useAuthStore();

const title = "Employee Dashboard";
const text = "Dashboard";
const text1 = "Employee Dashboard";

function hasPermission(permission) {
  if (!permission) return false;
  return typeof auth.can === "function"
    ? auth.can(permission)
    : false;
}

/** Matches sidebar: employee attendance self-service. */
const showAttendanceDashboard = computed(
  () =>
    hasPermission("Attendance.Read") ||
    hasPermission("Attendance.Create"),
);

/** Projects / tasks widget (project module + task permissions). */
const showProjectsTasks = computed(
  () => hasPermission("Task.Read") || hasPermission("Project.Read"),
);

const showPayrollSelfService = computed(
  () =>
    hasPermission("Payroll.ReadSelf") ||
    hasPermission("Payroll.Read"),
);
</script>
